import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import {
  Container, Grid, Box, Typography, Chip, Card, CardContent, CircularProgress,
  Button, FormGroup, FormControlLabel, Checkbox, Autocomplete, TextField,
  LinearProgress, Stack, Select, MenuItem, FormControl, InputLabel, Paper
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { createChart, ColorType } from 'lightweight-charts';

const isProduction = process.env.NODE_ENV === 'production';

const ALL_API_OPTIONS = [
  { label: 'Production API', value: 'https://dseapi.sadhanlab.com' },
  { label: 'Local Host', value: 'http://localhost:8000' }
];

const API_BASE_OPTIONS = isProduction
  ? ALL_API_OPTIONS.filter(opt => opt.value === 'https://dseapi.sadhanlab.com')
  : ALL_API_OPTIONS;

// /* =========================================================
//    1. CHART COMPONENT
//    ========================================================= */
// const TechnicalChart = ({ data, indicatorsVisible }) => {
//   const chartContainerRef = useRef(null);
//   const chartRef = useRef(null);
//   const seriesRefs = useRef({});

//   useEffect(() => {
//     if (!chartContainerRef.current) return;

//     const chart = createChart(chartContainerRef.current, {
//       width: chartContainerRef.current.clientWidth,
//       height: 520,
//       layout: { 
//         background: { type: ColorType.Solid, color: '#FFFFFF' }, 
//         textColor: '#334155' 
//       },
//       grid: { 
//         vertLines: { color: '#E2E8F0' }, 
//         horzLines: { color: '#E2E8F0' } 
//       },
//       timeScale: { borderColor: '#CBD5E1' },
//     });

//     chartRef.current = chart;

//     seriesRefs.current.candleSeries = chart.addCandlestickSeries({
//       upColor: '#10B981', downColor: '#EF4444', borderVisible: false,
//       wickUpColor: '#10B981', wickDownColor: '#EF4444'
//     });
//     seriesRefs.current.sma20Series = chart.addLineSeries({ color: '#2563EB', lineWidth: 1.5 });
//     seriesRefs.current.sma50Series = chart.addLineSeries({ color: '#D97706', lineWidth: 1.5 });
//     seriesRefs.current.sma200Series = chart.addLineSeries({ color: '#DB2777', lineWidth: 2 });
//     seriesRefs.current.bbUpper = chart.addLineSeries({ color: 'rgba(100, 116, 139, 0.5)', lineWidth: 1 });
//     seriesRefs.current.bbLower = chart.addLineSeries({ color: 'rgba(100, 116, 139, 0.5)', lineWidth: 1 });

//     const handleResize = () => chart.applyOptions({ width: chartContainerRef.current.clientWidth });
//     window.addEventListener('resize', handleResize);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//       chart.remove();
//       chartRef.current = null;
//     };
//   }, []);

//   useEffect(() => {
//     if (!data || data.length === 0 || !seriesRefs.current.candleSeries) return;

//     const { candleSeries, sma20Series, sma50Series, sma200Series, bbUpper, bbLower } = seriesRefs.current;

//     candleSeries.setData(data.map(d => ({ time: d.time, open: d.open, high: d.high, low: d.low, close: d.close })));

//     sma20Series.setData(indicatorsVisible.sma20 ? data.filter(d => d.sma_20).map(d => ({ time: d.time, value: d.sma_20 })) : []);
//     sma50Series.setData(indicatorsVisible.sma50 ? data.filter(d => d.sma_50).map(d => ({ time: d.time, value: d.sma_50 })) : []);
//     sma200Series.setData(indicatorsVisible.sma200 ? data.filter(d => d.sma_200).map(d => ({ time: d.time, value: d.sma_200 })) : []);
    
//     bbUpper.setData(indicatorsVisible.bollinger ? data.filter(d => d.bb_upper).map(d => ({ time: d.time, value: d.bb_upper })) : []);
//     bbLower.setData(indicatorsVisible.bollinger ? data.filter(d => d.bb_lower).map(d => ({ time: d.time, value: d.bb_lower })) : []);

//     const markers = [];
//     data.forEach(d => {
//       if (d.signal === 'BUY') markers.push({ time: d.time, position: 'belowBar', color: '#10B981', shape: 'arrowUp', text: 'BUY' });
//       else if (d.signal === 'SELL') markers.push({ time: d.time, position: 'aboveBar', color: '#EF4444', shape: 'arrowDown', text: 'SELL' });
//     });
//     candleSeries.setMarkers(markers);
//   }, [data, indicatorsVisible]);

//   return (
//     <Paper elevation={0} sx={{ p: 2, backgroundColor: '#FFFFFF', borderRadius: 3, border: '1px solid #E2E8F0' }}>
//       <Typography variant="h6" sx={{ color: '#0F172A', mb: 1, fontWeight: 600, fontSize: '1rem' }}>
//         Interactive Technical Execution
//       </Typography>

//       {/* Container with relative positioning for dynamic overlay legend */}
//       <Box sx={{ position: 'relative', width: '100%' }}>

//         {/* Dynamic Legend Overlay with Line-Matched Text Colors */}
//         {Object.values(indicatorsVisible).some(Boolean) && (
//           <Box 
//             sx={{ 
//               position: 'absolute', 
//               top: 12, 
//               left: 12, 
//               zIndex: 10, 
//               display: 'flex', 
//               flexWrap: 'wrap', 
//               gap: 1.5, 
//               backgroundColor: 'rgba(255, 255, 255, 0.9)', 
//               backdropFilter: 'blur(4px)',
//               p: '6px 12px', 
//               borderRadius: 1.5, 
//               border: '1px solid #E2E8F0',
//               boxShadow: '0px 1px 3px rgba(0,0,0,0.05)'
//             }}
//           >
//             {indicatorsVisible.sma20 && (
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
//                 <Box sx={{ width: 14, height: 0, borderBottom: '2px solid #2563EB' }} />
//                 <Typography variant="caption" sx={{ fontWeight: 700, color: '#2563EB' }}>
//                   SMA 20
//                 </Typography>
//               </Box>
//             )}

//             {indicatorsVisible.sma50 && (
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
//                 <Box sx={{ width: 14, height: 0, borderBottom: '2px solid #D97706' }} />
//                 <Typography variant="caption" sx={{ fontWeight: 700, color: '#D97706' }}>
//                   SMA 50
//                 </Typography>
//               </Box>
//             )}

//             {indicatorsVisible.sma200 && (
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
//                 <Box sx={{ width: 14, height: 0, borderBottom: '2.5px solid #DB2777' }} />
//                 <Typography variant="caption" sx={{ fontWeight: 700, color: '#DB2777' }}>
//                   SMA 200
//                 </Typography>
//               </Box>
//             )}

//             {indicatorsVisible.bollinger && (
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
//                   <Box sx={{ width: 14, height: 0, borderBottom: '1.5px solid #64748B' }} />
//                   <Box sx={{ width: 14, height: 0, borderBottom: '1.5px solid #64748B' }} />
//                 </Box>
//                 <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748B' }}>
//                   Bollinger Bands
//                 </Typography>
//               </Box>
//             )}
//           </Box>
//         )}

//         {/* Chart Viewport */}
//         <div ref={chartContainerRef} style={{ width: '100%', position: 'relative' }} />
//       </Box>
//     </Paper>
//   );
// };







/* =========================================================
   1. CHART COMPONENT with volume
   ========================================================= */
const TechnicalChart = ({ data, indicatorsVisible }) => {
  const chartContainerRef = useRef(null);
  const chartRef = useRef(null);
  const seriesRefs = useRef({});

  useEffect(() => {
    if (!chartContainerRef.current) return;

    const chart = createChart(chartContainerRef.current, {
      width: chartContainerRef.current.clientWidth,
      height: 520,
      layout: { 
        background: { type: ColorType.Solid, color: '#FFFFFF' }, 
        textColor: '#334155' 
      },
      grid: { 
        vertLines: { color: '#E2E8F0' }, 
        horzLines: { color: '#E2E8F0' } 
      },
      timeScale: { borderColor: '#CBD5E1' },
    });

    chartRef.current = chart;

    seriesRefs.current.candleSeries = chart.addCandlestickSeries({
      upColor: '#10B981', downColor: '#EF4444', borderVisible: false,
      wickUpColor: '#10B981', wickDownColor: '#EF4444'
    });

    // Add Volume Histogram Series with a separate price scale (overlay at the bottom)
    seriesRefs.current.volumeSeries = chart.addHistogramSeries({
      color: '#26a69a',
      priceFormat: {
        type: 'volume',
      },
      priceScaleId: '', // Set as overlay on the main pane or unique scale
    });

    // Configure price scale for volume so it occupies only the bottom 20-30% of the chart
    chart.priceScale('').applyOptions({
      scaleMargins: {
        top: 0.8, // Highest volume bar will peak at 20% from the top
        bottom: 0,
    },
    });

    seriesRefs.current.sma20Series = chart.addLineSeries({ color: '#2563EB', lineWidth: 1.5 });
    seriesRefs.current.sma50Series = chart.addLineSeries({ color: '#D97706', lineWidth: 1.5 });
    seriesRefs.current.sma200Series = chart.addLineSeries({ color: '#DB2777', lineWidth: 2 });
    seriesRefs.current.bbUpper = chart.addLineSeries({ color: 'rgba(100, 116, 139, 0.5)', lineWidth: 1 });
    seriesRefs.current.bbLower = chart.addLineSeries({ color: 'rgba(100, 116, 139, 0.5)', lineWidth: 1 });

    const handleResize = () => chart.applyOptions({ width: chartContainerRef.current.clientWidth });
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      chart.remove();
      chartRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!data || data.length === 0 || !seriesRefs.current.candleSeries) return;

    const { candleSeries, volumeSeries, sma20Series, sma50Series, sma200Series, bbUpper, bbLower } = seriesRefs.current;

    candleSeries.setData(data.map(d => ({ time: d.time, open: d.open, high: d.high, low: d.low, close: d.close })));

    // Set Volume Data with dynamic coloring (green if close >= open, red if close < open)
    if (volumeSeries) {
      const volumeData = data.map(d => ({
        time: d.time,
        value: d.volume,
        color: d.close >= d.open ? 'rgba(16, 185, 129, 0.4)' : 'rgba(239, 68, 68, 0.4)'
      }));
      volumeSeries.setData(volumeData);
    }

    sma20Series.setData(indicatorsVisible.sma20 ? data.filter(d => d.sma_20).map(d => ({ time: d.time, value: d.sma_20 })) : []);
    sma50Series.setData(indicatorsVisible.sma50 ? data.filter(d => d.sma_50).map(d => ({ time: d.time, value: d.sma_50 })) : []);
    sma200Series.setData(indicatorsVisible.sma200 ? data.filter(d => d.sma_200).map(d => ({ time: d.time, value: d.sma_200 })) : []);
    
    bbUpper.setData(indicatorsVisible.bollinger ? data.filter(d => d.bb_upper).map(d => ({ time: d.time, value: d.bb_upper })) : []);
    bbLower.setData(indicatorsVisible.bollinger ? data.filter(d => d.bb_lower).map(d => ({ time: d.time, value: d.bb_lower })) : []);

    const markers = [];
    data.forEach(d => {
      if (d.signal === 'BUY') markers.push({ time: d.time, position: 'belowBar', color: '#10B981', shape: 'arrowUp', text: 'BUY' });
      else if (d.signal === 'SELL') markers.push({ time: d.time, position: 'aboveBar', color: '#EF4444', shape: 'arrowDown', text: 'SELL' });
    });
    candleSeries.setMarkers(markers);
  }, [data, indicatorsVisible]);

  return (
    <Paper elevation={0} sx={{ p: 2, backgroundColor: '#FFFFFF', borderRadius: 3, border: '1px solid #E2E8F0' }}>
      <Typography variant="h6" sx={{ color: '#0F172A', mb: 1, fontWeight: 600, fontSize: '1rem' }}>
        Interactive Technical Execution
      </Typography>

      {/* Container with relative positioning for dynamic overlay legend */}
      <Box sx={{ position: 'relative', width: '100%' }}>

        {/* Dynamic Legend Overlay with Line-Matched Text Colors */}
        {Object.values(indicatorsVisible).some(Boolean) && (
          <Box 
            sx={{ 
              position: 'absolute', 
              top: 12, 
              left: 12, 
              zIndex: 10, 
              display: 'flex', 
              flexWrap: 'wrap', 
              gap: 1.5, 
              backgroundColor: 'rgba(255, 255, 255, 0.9)', 
              backdropFilter: 'blur(4px)',
              p: '6px 12px', 
              borderRadius: 1.5, 
              border: '1px solid #E2E8F0',
              boxShadow: '0px 1px 3px rgba(0,0,0,0.05)'
            }}
          >
            {indicatorsVisible.sma20 && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                <Box sx={{ width: 14, height: 0, borderBottom: '2px solid #2563EB' }} />
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#2563EB' }}>
                  SMA 20
                </Typography>
              </Box>
            )}

            {indicatorsVisible.sma50 && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                <Box sx={{ width: 14, height: 0, borderBottom: '2px solid #D97706' }} />
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#D97706' }}>
                  SMA 50
                </Typography>
              </Box>
            )}

            {indicatorsVisible.sma200 && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                <Box sx={{ width: 14, height: 0, borderBottom: '2.5px solid #DB2777' }} />
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#DB2777' }}>
                  SMA 200
                </Typography>
              </Box>
            )}

            {indicatorsVisible.bollinger && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                  <Box sx={{ width: 14, height: 0, borderBottom: '1.5px solid #64748B' }} />
                  <Box sx={{ width: 14, height: 0, borderBottom: '1.5px solid #64748B' }} />
                </Box>
                <Typography variant="caption" sx={{ fontWeight: 700, color: '#64748B' }}>
                  Bollinger Bands
                </Typography>
              </Box>
            )}
          </Box>
        )}

        {/* Chart Viewport */}
        <div ref={chartContainerRef} style={{ width: '100%', position: 'relative' }} />
      </Box>
    </Paper>
  );
};










/* =========================================================
   2. MAIN PAGE COMPONENT
   ========================================================= */
export const TechnicalAnalysisPage = () => {
  const { symbol = 'GP' } = useParams();
  
  const [baseUrl, setBaseUrl] = useState('https://dseapi.sadhanlab.com');
  const [symbolList, setSymbolList] = useState([]);
  const [selectedStock, setSelectedStock] = useState({ symbol: symbol, name: symbol });
  const [taData, setTaData] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [symbolsLoading, setSymbolsLoading] = useState(true);
  const [toggles, setToggles] = useState({ sma20: true, sma50: true, sma200: true, bollinger: false });

  const apiClient = axios.create({ baseURL: baseUrl });

  useEffect(() => {
    const fetchSymbols = async () => {
      setSymbolsLoading(true);
      try {
        const res = await apiClient.get('/api/technical-analysis/symbollist/all');
        const formatted = res.data.map(item => typeof item === 'string' ? { symbol: item, name: item } : item);
        setSymbolList(formatted);
        
        const initial = formatted.find(s => s.symbol === symbol) || { symbol: symbol, name: symbol };
        setSelectedStock(initial);
      } catch (err) {
        console.error("Failed to load symbols, using fallback list:", err);

        const fallback = [
          // Banking Sector
          { symbol: 'ABBANK', name: 'AB Bank PLC' },
          { symbol: 'ALARABANK', name: 'Al-Arafah Islami Bank PLC' },
          { symbol: 'BANKASIA', name: 'Bank Asia PLC' },
          { symbol: 'BRACBANK', name: 'BRAC Bank PLC' },
          { symbol: 'CITYBANK', name: 'The City Bank PLC' },
          { symbol: 'DHAKABANK', name: 'Dhaka Bank PLC' },
          { symbol: 'DUTCHBANGL', name: 'Dutch-Bangla Bank PLC' },
          { symbol: 'EBL', name: 'Eastern Bank PLC' },
          { symbol: 'EXIMBANK', name: 'EXIM Bank PLC' },
          { symbol: 'FIRSTSBANK', name: 'First Security Islami Bank PLC' },
          { symbol: 'IFIC', name: 'IFIC Bank PLC' },
          { symbol: 'ISLAMIBANK', name: 'Islami Bank Bangladesh PLC' },
          { symbol: 'JAMUNABANK', name: 'Jamuna Bank PLC' },
          { symbol: 'LANKABANFL', name: 'LankaBangla Finance PLC' },
          { symbol: 'MERCANBANK', name: 'Mercantile Bank PLC' },
          { symbol: 'MTB', name: 'Mutual Trust Bank PLC' },
          { symbol: 'NBL', name: 'National Bank PLC' },
          { symbol: 'NCCBANK', name: 'NCC Bank PLC' },
          { symbol: 'NRBCBANK', name: 'NRB Commercial Bank PLC' },
          { symbol: 'ONEBANK', name: 'ONE Bank PLC' },
          { symbol: 'PREMIERBAN', name: 'The Premier Bank PLC' },
          { symbol: 'PRIMEBANK', name: 'Prime Bank PLC' },
          { symbol: 'PUBALIBANK', name: 'Pubali Bank PLC' },
          { symbol: 'RUPALIBANK', name: 'Rupali Bank PLC' },
          { symbol: 'SBACBANK', name: 'SBAC Bank PLC' },
          { symbol: 'SHAHJABANK', name: 'Shahjalal Islami Bank PLC' },
          { symbol: 'SIBL', name: 'Social Islami Bank PLC' },
          { symbol: 'SOUTHEASTB', name: 'Southeast Bank PLC' },
          { symbol: 'STANBANK', name: 'Standard Bank PLC' },
          { symbol: 'TRUSTBANK', name: 'Trust Bank PLC' },
          { symbol: 'UBL', name: 'United Commercial Bank PLC' },
          { symbol: 'UTTARABANK', name: 'Uttara Bank PLC' },

          // Pharmaceuticals & Chemicals
          { symbol: 'ACEL', name: 'ACI Formulations Limited' },
          { symbol: 'ACI', name: 'ACI Limited' },
          { symbol: 'AMBEEPHA', name: 'Ambee Pharmaceuticals PLC' },
          { symbol: 'BEACONPHA', name: 'Beacon Pharmaceuticals PLC' },
          { symbol: 'BEXIMCO', name: 'Beximco Limited' },
          { symbol: 'BXPHARMA', name: 'Beximco Pharmaceuticals Ltd.' },
          { symbol: 'CENTRALPHA', name: 'Central Pharmaceuticals Ltd.' },
          { symbol: 'IBNSINA', name: 'The IBN SINA Pharmaceutical Industry PLC' },
          { symbol: 'JMISMDL', name: 'JMI Syringes & Medical Devices Ltd.' },
          { symbol: 'KEYACOSMET', name: 'Keya Cosmetics Ltd.' },
          { symbol: 'MARICO', name: 'Marico Bangladesh Limited' },
          { symbol: 'NAVANAPHAR', name: 'Navana Pharmaceuticals PLC' },
          { symbol: 'ORIONINFU', name: 'Orion Infusion Ltd.' },
          { symbol: 'ORIONPHARM', name: 'Orion Pharma Ltd.' },
          { symbol: 'RENATA', name: 'Renata Limited' },
          { symbol: 'SQURPHARMA', name: 'Square Pharmaceuticals PLC' },

          // Telecommunication & Technology
          { symbol: 'AAMRATECH', name: 'aamra technologies limited' },
          { symbol: 'AAMRANET', name: 'aamra networks limited' },
          { symbol: 'ADNTEL', name: 'ADN Telecom Limited' },
          { symbol: 'BDCOM', name: 'BDCOM Online Ltd.' },
          { symbol: 'GENEXIL', name: 'Genex Infosys Limited' },
          { symbol: 'GP', name: 'Grameenphone Ltd.' },
          { symbol: 'ITSCBL', name: 'IT Consultants PLC' },
          { symbol: 'ROBI', name: 'Robi Axiata Limited' },

          // Engineering & Manufacturing
          { symbol: 'AFTABAUTO', name: 'Aftab Automobiles Ltd.' },
          { symbol: 'ANWARGALV', name: 'Anwar Galvanizing Ltd.' },
          { symbol: 'APPOLO', name: 'Appollo Ispat Complex Limited' },
          { symbol: 'BBSCABLES', name: 'BBS Cables PLC' },
          { symbol: 'BSRMSTEEL', name: 'BSRM Steels Limited' },
          { symbol: 'BSRMTOST', name: 'Bangladesh Steel Re-Rolling Mills Ltd.' },
          { symbol: 'GPHISPAT', name: 'GPH Ispat Ltd.' },
          { symbol: 'IFADAUTOS', name: 'IFAD Autos PLC' },
          { symbol: 'NAVANARNG', name: 'Navana CNG Limited' },
          { symbol: 'RUNNERAUTO', name: 'Runner Automobiles PLC' },
          { symbol: 'SINGERBD', name: 'Singer Bangladesh Limited' },
          { symbol: 'WALTONHI', name: 'Walton Hi-Tech Industries PLC' },

          // Food & Allied
          { symbol: 'BATBC', name: 'British American Tobacco Bangladesh' },
          { symbol: 'BANGAS', name: 'Bangas Ltd.' },
          { symbol: 'EMERALDOIL', name: 'Emerald Oil Industries Ltd.' },
          { symbol: 'FUWANGFOOD', name: 'Fu Wang Food Ltd.' },
          { symbol: 'GEMINISEA', name: 'Gemini Sea Food PLC' },
          { symbol: 'MUPHERM', name: 'Mullert & Phipps (BD) Ltd.' },
          { symbol: 'NTC', name: 'National Tea Company Ltd.' },
          { symbol: 'OLYMPIC', name: 'Olympic Industries Limited' },
          { symbol: 'RDFOOD', name: 'Rangpur Dairy & Food Products Ltd.' },
          { symbol: 'UNILEVERCL', name: 'Unilever Consumer Care Limited' },

          // Fuel & Power
          { symbol: 'BARKAPOWER', name: 'Barka Power Limited' },
          { symbol: 'DESCO', name: 'Dhaka Electric Supply Company Ltd.' },
          { symbol: 'DOREENPWR', name: 'Doreen Power Generations and Systems Ltd.' },
          { symbol: 'EASTRNLUB', name: 'Eastern Lubricants Blenders PLC' },
          { symbol: 'GBBPOWER', name: 'GBB Power Ltd.' },
          { symbol: 'MJLBD', name: 'MJL Bangladesh PLC' },
          { symbol: 'MPETROLEUM', name: 'Meghna Petroleum Limited' },
          { symbol: 'PADMAPOIL', name: 'Padma Oil Company Limited' },
          { symbol: 'POWERGRID', name: 'Power Grid Company of Bangladesh Ltd.' },
          { symbol: 'SUMITPOWER', name: 'Summit Power Limited' },
          { symbol: 'TITASGAS', name: 'Titas Gas Transmission & Distribution Co. Ltd.' },
          { symbol: 'UPGDCL', name: 'United Power Generation & Distribution Co. Ltd.' },

          // Cement & Real Estate
          { symbol: 'ARAMITCIT', name: 'Aramit Cement Limited' },
          { symbol: 'CONFIDCEM', name: 'Confidence Cement PLC' },
          { symbol: 'HEIDELBCEM', name: 'Heidelberg Materials Bangladesh PLC' },
          { symbol: 'LHBL', name: 'LafargeHolcim Bangladesh Limited' },
          { symbol: 'MEGHNACEM', name: 'Meghna Cement Mills PLC' },
          { symbol: 'PREMIERCEM', name: 'Premier Cement Mills PLC' },
          { symbol: 'EASTERNSHA', name: 'Eastern Housing Limited' },

          // Textiles
          { symbol: 'AL-HAJTEX', name: 'Al-Haj Textile Mills Limited' },
          { symbol: 'ENVOYTEX', name: 'Envoy Textiles Limited' },
          { symbol: 'MALEKSPIN', name: 'Malek Spinning Mills Ltd.' },
          { symbol: 'MATINSPINN', name: 'Matin Spinning Mills PLC' },
          { symbol: 'PARAMOUNT', name: 'Paramount Textile PLC' },
          { symbol: 'SQUARETEXT', name: 'Square Textiles PLC' },

          // Services, Logistics & Miscellaneous
          { symbol: 'AMAPROP', name: 'Aman Properties PLC' },
          { symbol: 'BERGERPBL', name: 'Berger Paints Bangladesh Limited' },
          { symbol: 'BISCIND', name: 'Bangladesh Submarine Cable Company Limited' },
          { symbol: 'UNIQUEHOTE', name: 'Unique Hotel & Resorts PLC' }
        ];

        setSymbolList(fallback);
        setSelectedStock(fallback.find(s => s.symbol === symbol) || fallback[0]);
      } finally {
        setSymbolsLoading(false);
      }
    };
    fetchSymbols();
  }, [baseUrl]);

  useEffect(() => {
    if (!selectedStock?.symbol) return;
    const fetchData = async () => {
      setLoading(true);
      try {
        const [resSummary, resHistory] = await Promise.all([
          apiClient.get(`/api/technical-analysis/${selectedStock.symbol}/`),
          apiClient.get(`/api/technical-analysis/${selectedStock.symbol}/history/`)
        ]);
        setTaData(resSummary.data);
        setHistory(resHistory.data);
      } catch (err) {
        console.error("Failed to load TA details:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [selectedStock, baseUrl]);

  const getSignalColor = (sig) => sig === 'BUY' ? '#10B981' : sig === 'SELL' ? '#EF4444' : '#64748B';

  const latest = taData?.latest || {};
  const backtest = taData?.backtest || {};

  return (
    <Container maxWidth="xl" sx={{ mt: 3, mb: 4 }}>
      {/* Top Controls Header */}
      <Grid container spacing={2} alignItems="center" sx={{ mb: 3 }}>
        
        {/* Dynamic Stock Selection - Made Wider with Smaller Font */}
        <Grid item xs={12} sm={8} md={isProduction ? 6 : 5}>
          <Autocomplete
            options={symbolList}
            loading={symbolsLoading}
            getOptionLabel={(option) => `${option.name} (${option.symbol})`}
            value={selectedStock}
            isOptionEqualToValue={(option, value) => option.symbol === value.symbol}
            onChange={(e, val) => val && setSelectedStock(val)}
            slotProps={{
              paper: {
                sx: {
                  fontSize: '0.85rem',
                  minWidth: { xs: '100%', sm: '380px' }
                }
              }
            }}
            renderInput={(params) => {
              const { InputProps, ...restParams } = params;
              return (
                <TextField 
                  {...restParams} 
                  label="Select Market Ticker / Product" 
                  variant="outlined" 
                  size="small"
                  sx={{ 
                    minWidth: { xs: '100%', sm: 320 },
                    '& .MuiInputBase-input': { fontSize: '0.875rem' },
                    '& .MuiInputLabel-root': { fontSize: '0.85rem' }
                  }}
                  InputProps={{
                    ...InputProps,
                    endAdornment: (
                      <>
                        {symbolsLoading ? <CircularProgress color="inherit" size={16} /> : null}
                        {InputProps?.endAdornment}
                      </>
                    ),
                  }}
                />
              );
            }}
          />
        </Grid>
        
        {/* API Selector - Dev Only */}
        {!isProduction && (
          <Grid item xs={12} sm={4} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel id="api-base-label" sx={{ fontSize: '0.85rem' }}>API Env</InputLabel>
              <Select
                labelId="api-base-label"
                value={baseUrl}
                onChange={(e) => setBaseUrl(e.target.value)}
                label="API Env"
                sx={{ fontSize: '0.85rem' }}
              >
                {API_BASE_OPTIONS.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: '0.85rem' }}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        {/* Responsive Action Buttons Container */}
        <Grid 
          item 
          xs={12} 
          md={isProduction ? 6 : 5} 
          display="flex" 
          justifyContent={{ xs: 'flex-start', sm: 'flex-end' }} 
          alignItems="center"
          gap={{ xs: 1.5, sm: 2 }}
          flexWrap="wrap"
        >
          {/* <Button 
            variant="contained" 
            color="secondary" 
            size="small"
            startIcon={<NotificationsActiveIcon sx={{ fontSize: '1.1rem !important' }} />}
            sx={{ 
              fontSize: '0.8rem', 
              py: 0.9, 
              px: 2, 
              flex: { xs: '1 1 100%', sm: 'none' } 
            }}
          >
            Set Alert Trigger
          </Button> */}
          <Button 
            variant="outlined" 
            size="small"
            startIcon={<DownloadIcon sx={{ fontSize: '1.1rem !important' }} />} 
            onClick={() => window.open(`${baseUrl}/api/technical-analysis/${selectedStock.symbol}/export/`, '_blank')}
            sx={{ 
              fontSize: '0.8rem', 
              py: 0.9, 
              px: 2, 
              flex: { xs: '1 1 100%', sm: 'none' } 
            }}
          >
            Export Signals (.CSV)
          </Button>
        </Grid>
      </Grid>

      {/* Dynamic Stock Header Banner */}
      <Paper elevation={0} sx={{ p: 2, mb: 3, backgroundColor: '#1E293B', color: '#FFFFFF', borderRadius: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <ShowChartIcon sx={{ fontSize: 30, color: '#38BDF8' }} />
          <Box>
            <Typography variant="caption" sx={{ textTransform: 'uppercase', color: '#94A3B8', letterSpacing: 1, fontWeight: 600, fontSize: '0.7rem' }}>
              Active Technical Analysis
            </Typography>
            <Typography variant="h6" fontWeight="700" sx={{ fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>
              {selectedStock.name} <span style={{ color: '#38BDF8' }}>({selectedStock.symbol})</span>
            </Typography>
          </Box>
        </Box>
        <Chip label={`Ticker: ${selectedStock.symbol}`} size="small" sx={{ backgroundColor: '#334155', color: '#F1F5F9', fontWeight: 600, fontSize: '0.75rem' }} />
      </Paper>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <>
          {/* Main Indicators Dashboard */}
          <Grid container spacing={2.5} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6} md={4}>
              <Card sx={{ height: '100%', backgroundColor: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: 3 }}>
                <CardContent>
                  <Typography variant="overline" color="#64748B" fontSize="0.7rem">Current Signal State</Typography>
                  <Box display="flex" alignItems="center" gap={1.5} my={1}>
                    <Chip label={latest.signal || 'HOLD'} sx={{ backgroundColor: getSignalColor(latest.signal), color: '#FFF', fontWeight: 'bold', fontSize: '1rem', px: 1.5 }} />
                    <Typography variant="subtitle1" color="#0F172A" fontWeight="600">Score: {latest.confidence_score || 0}/100</Typography>
                  </Box>
                  <Box mt={2}>
                    <Typography variant="body2" color="#64748B" mb={0.5} fontSize="0.8rem">Signal Confidence Intensity</Typography>
                    <LinearProgress variant="determinate" value={latest.confidence_score || 0} sx={{ height: 6, borderRadius: 2, backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: getSignalColor(latest.signal) } }} />
                  </Box>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={5}>
              <Card sx={{ height: '100%', backgroundColor: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: 3 }}>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight="600" color="#0F172A" mb={1} fontSize="0.95rem">Decision Rationale</Typography>
                  <Stack gap={1}>
                    {latest.signal_reasons?.map((reason, idx) => (
                      <Box key={idx} sx={{ p: 1, borderRadius: 2, backgroundColor: '#F8FAFC', borderLeft: `4px solid ${getSignalColor(latest.signal)}` }}>
                        <Typography variant="body2" color="#334155" fontSize="0.8rem">{reason}</Typography>
                      </Box>
                    ))}
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={3}>
              <Card sx={{ height: '100%', backgroundColor: '#FFFFFF', border: '1px solid #E2E8F0', borderRadius: 3 }}>
                <CardContent>
                  <Box display="flex" alignItems="center" gap={1} mb={0.5}>
                    <TrendingUpIcon sx={{ color: '#10B981', fontSize: '1.2rem' }} />
                    <Typography variant="overline" color="#64748B" fontSize="0.7rem">3-Year Backtest Metric</Typography>
                  </Box>
                  <Typography variant="h4" sx={{ color: (backtest.total_return_pct || 0) >= 0 ? '#10B981' : '#EF4444', fontWeight: 700, my: 0.5, fontSize: '1.75rem' }}>
                    {backtest.total_return_pct || 0}%
                  </Typography>
                  <Typography variant="body2" color="#64748B" fontSize="0.8rem">Win Rate: <b>{backtest.win_rate_pct || 0}%</b> ({backtest.trades_count || 0} Trades)</Typography>
                  <Typography variant="body2" color="#64748B" fontSize="0.8rem">Max Drawdown: <b>{backtest.max_drawdown_pct || 0}%</b></Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Indicator Checkboxes with Line-Matching Colors */}
          <Box sx={{ mb: 2, p: 1, backgroundColor: '#FFFFFF', borderRadius: 2, border: '1px solid #E2E8F0' }}>
            <FormGroup row sx={{ gap: { xs: 1, sm: 2 } }}>
              <FormControlLabel 
                control={<Checkbox size="small" checked={toggles.sma20} onChange={(e) => setToggles({ ...toggles, sma20: e.target.checked })} sx={{ color: '#2563EB', '&.Mui-checked': { color: '#2563EB' } }} />} 
                label={<Typography fontSize="0.8rem" fontWeight="600" color="#2563EB">SMA 20</Typography>} 
              />
              <FormControlLabel 
                control={<Checkbox size="small" checked={toggles.sma50} onChange={(e) => setToggles({ ...toggles, sma50: e.target.checked })} sx={{ color: '#D97706', '&.Mui-checked': { color: '#D97706' } }} />} 
                label={<Typography fontSize="0.8rem" fontWeight="600" color="#D97706">SMA 50</Typography>} 
              />
              <FormControlLabel 
                control={<Checkbox size="small" checked={toggles.sma200} onChange={(e) => setToggles({ ...toggles, sma200: e.target.checked })} sx={{ color: '#DB2777', '&.Mui-checked': { color: '#DB2777' } }} />} 
                label={<Typography fontSize="0.8rem" fontWeight="600" color="#DB2777">SMA 200</Typography>} 
              />
              <FormControlLabel 
                control={<Checkbox size="small" checked={toggles.bollinger} onChange={(e) => setToggles({ ...toggles, bollinger: e.target.checked })} sx={{ color: '#64748B', '&.Mui-checked': { color: '#64748B' } }} />} 
                label={<Typography fontSize="0.8rem" fontWeight="600" color="#64748B">Bollinger Bands</Typography>} 
              />
            </FormGroup>
          </Box>

          <TechnicalChart data={history} indicatorsVisible={toggles} />
        </>
      )}
    </Container>
  );
};